import useMixin from './use_mixin';
import useTimeout from './use_timeout';

export default function useTemporaryContent(controller, target, content, timeout) {
  const isHTMLInputElement = target.tagName === 'INPUT';

  const setContent = (element, text) => {
    const el = element;
    if (isHTMLInputElement) {
      el.value = text;
    } else {
      el.innerHTML = text;
    }
  };

  const getContent = (element) => (isHTMLInputElement ? element.value : element.innerHTML);

  let cleanupTimeout = () => {};
  const originalText = getContent(target);

  const teardown = () => {
    setContent(target, originalText);
    cleanupTimeout();
  };

  const setup = () => {
    setContent(target, content);
    if (timeout !== undefined) {
      cleanupTimeout = useTimeout(controller, teardown, timeout);
    }
  };

  useMixin(controller, setup, teardown);

  return {
    teardown,
    update(newContent) {
      setContent(target, newContent);
    },
  };
}
